/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdminRole {
    SUPER_ADMIN = 'SuperAdmin',
    ADMIN = 'Admin',
    TRACKER = 'Tracker',
}
